import Nullstack from 'nullstack';
export default function IconAngle({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-angle",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M21 19h-18l9 -15"
  }), "   ", Nullstack.element("path", {
    d: "M20.615 15.171h.015"
  }), "   ", Nullstack.element("path", {
    d: "M19.515 11.771h.015"
  }), "   ", Nullstack.element("path", {
    d: "M17.715 8.671h.015"
  }), "   ", Nullstack.element("path", {
    d: "M15.415 5.971h.015"
  }), " ");
}